/* ============================================================
   Pholoh PDP description "read more".
   Clamps the description to a few lines with a soft fade, and
   reveals the rest on tap. If the copy is already short enough,
   the clamp + button are removed so there's nothing to click.
   ============================================================ */
(function () {
  'use strict';

  // Decide short vs long. "Short" = the whole description already fits the clamp (roughly two
  // lines or less of overflow-free copy) -> no button, shown as-is. Tolerance is ~half a line
  // so a trailing paragraph margin or a sub-pixel rounding can't force a pointless button.
  function evaluate(wrap) {
    var clip = wrap.querySelector('.pholoh-pdp-desc__clip');
    var btn = wrap.querySelector('[data-pholoh-readmore-btn]');
    if (!clip || !btn) return;
    if (wrap.classList.contains('is-open')) return;   // already expanded by the user — leave it
    var lh = parseFloat(getComputedStyle(clip).lineHeight);
    var tol = (lh && !isNaN(lh)) ? lh * 0.5 : 10;
    var isShort = clip.scrollHeight <= clip.clientHeight + tol;
    wrap.classList.toggle('is-short', isShort);       // is-short drops the clamp + fade (CSS)
    btn.hidden = isShort;                             // ...and hides the View more button
  }

  function setup(wrap) {
    var btn = wrap.querySelector('[data-pholoh-readmore-btn]');
    if (btn && !wrap.dataset.rmBound) {
      wrap.dataset.rmBound = '1';
      btn.addEventListener('click', function () {
        var open = wrap.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.textContent = open ? 'View less' : 'View more';
      });
    }
    evaluate(wrap);
  }

  function init() {
    document.querySelectorAll('[data-pholoh-readmore]').forEach(setup);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  // Re-measure once fonts/images settle so the short/long call is accurate, not guessed early.
  window.addEventListener('load', init);
  if (document.fonts && document.fonts.ready) { document.fonts.ready.then(init); }
})();

/* ============================================================
   Pholoh PDP info tabs — exclusive accordion.
   The Description / Size Guide / Shipping & taxes / Ask a question
   rows are native <details>. Open one and any other open one in the
   same product closes, so only a single tab is open at a time.
   (toggle doesn't bubble, so we listen on the document in capture
   phase; scoping to the product's blocks keeps quick-view modals
   and multiple products independent.)
   ============================================================ */
(function () {
  'use strict';
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.nodeName !== 'DETAILS' || !d.classList.contains('pholoh-acc') || !d.open) return;
    var scope = d.closest('[data-product-blocks]') || document;
    scope.querySelectorAll('details.pholoh-acc[open]').forEach(function (other) {
      if (other !== d) other.open = false;
    });
  }, true);
})();

/* ============================================================
   Pholoh PDP discount badge ("X% OFF - SAVE $Y").
   The Liquid version renders in product-template, but page HTML can be cached,
   so this reads the on-page prices and injects the badge next to the Judge.me
   stars — works even on a cached page (this asset loads fresh). No-ops if the
   Liquid badge is already present, or the product isn't on sale.
   ============================================================ */
(function () {
  'use strict';
  if (!document.body || document.body.className.indexOf('template-product') === -1) return;

  function toNum(str) {
    var s = ('' + (str || '')).replace(/[^0-9.,]/g, '');
    if (!s) return NaN;
    var dec = Math.max(s.lastIndexOf('.'), s.lastIndexOf(','));
    if (dec > -1 && s.length - dec <= 3) {           // last separator is a decimal
      return parseFloat(s.slice(0, dec).replace(/[.,]/g, '') + '.' + s.slice(dec + 1));
    }
    return parseFloat(s.replace(/[.,]/g, ''));        // separators are thousands only
  }
  function fmtSave(sample, val) {                     // reuse the compare price's currency wrapper
    var m = ('' + sample).match(/[0-9][0-9.,]*/);
    var hasDec = /[.,]\d{2}(?!\d)/.test(sample);
    var out = hasDec ? val.toFixed(2) : String(Math.round(val));
    return m ? sample.replace(m[0], out) : out;
  }

  function run() {
    if (document.querySelector('.pholoh-pdp-save')) return;          // Liquid badge already there
    var badge = document.querySelector('.jdgm-prev-badge');
    if (!badge) return;                                              // wait for Judge.me
    var cmpEl = document.querySelector('.product__price--compare');
    var saleEl = document.querySelector('[data-product-price]');
    if (!cmpEl || !saleEl || !cmpEl.textContent.trim()) return;
    var cmp = toNum(cmpEl.textContent), sale = toNum(saleEl.textContent);
    if (!(cmp > 0 && sale > 0 && cmp > sale)) return;

    var el = document.createElement('span');
    el.className = 'pholoh-pdp-save';
    el.textContent = '▼ ' + Math.round((cmp - sale) / cmp * 100) + '% OFF - SAVE ' + fmtSave(cmpEl.textContent.trim(), cmp - sale);

    var row = badge.closest('.pholoh-pdp-ratingrow');
    if (row) { row.appendChild(el); return; }
    // No Liquid row (cached HTML): wrap the badge + save in one so it lays out right/left.
    row = document.createElement('div');
    row.className = 'pholoh-pdp-ratingrow';
    badge.parentNode.insertBefore(row, badge);
    var stars = document.createElement('div');
    stars.className = 'pholoh-pdp-ratingrow__stars';
    stars.appendChild(badge);
    row.appendChild(stars);
    row.appendChild(el);
  }

  if (document.readyState !== 'loading') run();
  else document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  var mo = new MutationObserver(run);                                // Judge.me injects the stars late
  mo.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { mo.disconnect(); }, 9000);
})();
